/* lua.js generated code 0.3.0 */

/* 
Copyright (c) 2011-2014 chukong-inc.com

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

 */
printLog = function (tag, fmt) {
    var __VA_ARG = $slice(arguments, 2)
    var t = table(
        "[",
        [0, string.upper(tostring(tag))],
        "] ",
        [0, string.format(tostring(fmt), ...__VA_ARG)]
    )
    cc.log(table.concat(t))
}
printError = function (fmt) {
    var __VA_ARG = $slice(arguments, 1)
    printLog("ERR", fmt, ...__VA_ARG)
    cc.log(debug.traceback("", 2))
}
printInfo = function (fmt) {
    var __VA_ARG = $slice(arguments, 1)
    if (type(DEBUG) !== "number" || DEBUG < 2) {
        return 
    }
    printLog("INFO", fmt, ...__VA_ARG)
}
function dump_value_(v) {
    if (type(v) === "string") {
        v = "\"" + v + "\""
    }
    // WARN: maybe multi result
    return tostring(v)
}
dump = function (value, desciption, nesting) {
    if (type(nesting) !== "number") {
        nesting = 3
    }
    var lookupTable = table()
    var result = table()
    var traceback = string.split(debug.traceback("", 2), "\n")
    cc.log("dump from: " + string.trim(traceback[3]))
    function dump_(value, desciption, indent, nest, keylen) {
        desciption = desciption || "<var>"
        var spc = ""
        if (type(keylen) === "number") {
            spc = string.rep(" ", keylen - string.len(dump_value_(desciption)))
        }
        if (type(value) !== "table") {
            result[$len(result) + 1] = string.format("%s%s%s = %s", indent, dump_value_(desciption), spc, dump_value_(value))
        } else if (lookupTable[tostring(value)]) {
            result[$len(result) + 1] = string.format("%s%s%s = *REF*", indent, dump_value_(desciption), spc)
        } else {
            lookupTable[tostring(value)] = true
            if (nest > nesting) {
                result[$len(result) + 1] = string.format("%s%s = *MAX NESTING*", indent, dump_value_(desciption))
            } else {
                result[$len(result) + 1] = string.format("%s%s = {", indent, dump_value_(desciption))
                var indent2 = indent + "    "
                var keys = table()
                var keylen = 0
                var values = table()
                for (var k in value) {
                    var v = value[k]
                    keys[$len(keys) + 1] = k
                    var vk = dump_value_(k)
                    var vkl = string.len(vk)
                    if (vkl > keylen) {
                        keylen = vkl
                    }
                    values[k] = v
                }
                table.sort(keys, function (a, b) {
                    if (type(a) === "number" && type(b) === "number") {
                        return a < b
                    } else {
                        return tostring(a) < tostring(b)
                    }
                })
                for (var i = 1, k = keys[1]; k; i++, k = keys[i]) {
                    dump_(values[k], k, indent2, nest + 1, keylen)
                }
                result[$len(result) + 1] = string.format("%s}", indent)
            }
        }
    }
    dump_(value, desciption, "- ", 1)
    for (var i = 1, line = result[1]; line; i++, line = result[i]) {
        cc.log(line)
    }
}
printf = function (fmt) {
    var __VA_ARG = $slice(arguments, 1)
    cc.log(string.format(tostring(fmt), ...__VA_ARG))
}
checknumber = function (value, base) {
    return tonumber(value, base) || 0
}
checkint = function (value) {
    // WARN: maybe multi result
    return Math.round(checknumber(value))
}
checkbool = function (value) {
    return (value != null && value !== false)
}
checktable = function (value) {
    if (type(value) !== "table") {
        value = table()
    }
    return value
}
isset = function (hashtable, key) {
    var t = type(hashtable)
    return (t === "table" || t === "userdata") && hashtable[key] != null
}
var setmetatableindex_
setmetatableindex_ = function (t, index) {
    if (type(t) === "userdata") {
        var peer = tolua.getpeer(t)
        if (!peer) {
            peer = table()
            tolua.setpeer(t, peer)
        }
        setmetatableindex_(peer, index)
    } else {
        var mt = getmetatable(t)
        if (!mt) {
            mt = table()
        }
        if (!mt.__index) {
            mt.__index = index
            setmetatable(t, mt)
        } else if (mt.__index !== index) {
            setmetatableindex_(mt, index)
        }
    }
}
setmetatableindex = setmetatableindex_
clone = function (object) {
    var lookup_table = table()
    function _copy(object) {
        if (type(object) !== "table") {
            return object
        } else if (lookup_table[object]) {
            return lookup_table[object]
        }
        var newObject = table()
        lookup_table[object] = newObject
        for (var key in object) {
            var value = object[key]
            newObject[_copy(key)] = _copy(value)
        }
        // WARN: maybe multi result
        return setmetatable(newObject, getmetatable(object))
    }
    // WARN: maybe multi result
    return _copy(object)
}
clone = function(obj) {
    if(!obj){
        return obj
    }
    return extend(table(), obj)
}
xclass = function (classname) {
    var __VA_ARG = $slice(arguments, 1)
    if (!classname || type(classname) === "table") {
        assert(false, "error class definition!")
    }
    var cls = table([1, "__cname", classname])
    var supers = table([2, __VA_ARG])
    for (var _ = 1, xsuper = supers[1]; xsuper; _++, xsuper = supers[_]) {
        var superType = type(xsuper)
        assert(superType === "nil" || superType === "table" || superType === "function", string.format("class() - create class \"%s\" with invalid super class type \"%s\"", classname, superType))
        if (superType === "function") {
            assert(cls.__create == null, string.format("class() - create class \"%s\" with more than one creating function", classname))
            // if super is function, set it to __create
            cls.__create = xsuper
        } else if (superType === "table") {
            if (xsuper[".isclass"]) {
                // super is native class
                assert(cls.__create == null, string.format("class() - create class \"%s\" with more than one creating function or native class", classname))
                cls.__create = function () {
                    // WARN: maybe multi result
                    return xsuper.create()
                }
            } else {
                // super is pure lua class
                cls.__supers = cls.__supers || table()
                cls.__supers[$len(cls.__supers) + 1] = xsuper
                if (!cls.super) {
                    // set first super pure lua class as class.super
                    cls.super = xsuper
                }
            }
        } else {
            error(string.format("class() - create class \"%s\" with invalid super type", classname), 0)
        }
    }
    cls.__index = cls
    if (!cls.__supers || $len(cls.__supers) === 1) {
        setmetatable(cls, table([1, "__index", cls.super]))
    } else {
        setmetatable(cls, table([1, "__index", function (_, key) {
                var supers = cls.__supers
                var $limit33 = $len(supers)
                for (var i = 1; i <= $limit33; i += 1) {
                    var xsuper = supers[i]
                    if (xsuper[key]) {
                        return xsuper[key]
                    }
                }
            }]))
    }
    if (!cls.ctor) {
        // add default constructor
        cls.ctor = function () { }
    }
    cls.new = function () {
        var __VA_ARG = $slice(arguments, 0)
        var instance
        if (cls.__create) {
            instance = cls.__create(...__VA_ARG)
        } else {
            instance = table()
        }
        setmetatableindex(instance, cls)
        instance.class = cls
        instance.ctor(...__VA_ARG)
        return instance
    }
    cls.create = function (_) {
        var __VA_ARG = $slice(arguments, 1)
        // WARN: maybe multi result
        return cls.new(...__VA_ARG)
    }
    cls.is = function (obj, cls) {
        if (!obj || !cls) {
            return false
        }
        var __index = rawget(cls, "__index")
        var tarCName = rawget(__index, "__cname")
        // WARN: maybe multi result
        return iskindof(obj, tarCName)
    }
    cls.log = function (ctx, msg) {
        var __VA_ARG = $slice(arguments, 2)
        var param = table([2, __VA_ARG])
        for (var i = 1, v = param[1]; v; i++, v = param[i]) {
            param[i] = tostring(v)
        }
        var msg = string.format(tostring(msg), ...unpack(param))
        cc.log("[" + ctx.__cname + "] " + msg)
    }
    return cls
}
var iskindof_
iskindof_ = function (cls, name) {
    var __index = rawget(cls, "__index")
    if (type(__index) === "table" && rawget(__index, "__cname") === name) {
        return true
    }
    if (rawget(cls, "__cname") === name) {
        return true
    }
    var __supers = rawget(cls, "__supers")
    if (!__supers) {
        return false
    }
    for (var _ = 1, xsuper = __supers[1]; xsuper; _++, xsuper = __supers[_]) {
        if (iskindof_(xsuper, name)) {
            return true
        }
    }
    return false
}
iskindof = function (obj, classname) {
    var t = type(obj)
    if (t !== "table" && t !== "userdata") {
        return false
    }
    var mt
    if (t === "userdata") {
        if (tolua.iskindof(obj, classname)) {
            return true
        }
        mt = tolua.getpeer(obj)
    } else {
        mt = getmetatable(obj)
    }
    if (mt) {
        if (iskindof_(mt, classname)) {
            return true
        } else if (mt.class && iskindof_(mt.class, classname)) {
            return true
        }
    }
    return false
}
ximport = function (moduleName, currentModuleName) {
    var currentModuleNameParts
    var moduleFullName = moduleName
    var offset = 1
    while (true) {
        if (string.byte(moduleName, offset)[0] !== 46) { // .
            moduleFullName = string.sub(moduleName, offset)
            if (currentModuleNameParts && $len(currentModuleNameParts) > 0) {
                moduleFullName = table.concat(currentModuleNameParts, ".") + "." + moduleFullName
            }
            break
        }
        offset = offset + 1
        if (!currentModuleNameParts) {
            if (!currentModuleName) {
                var [n, v] = debug.getlocal(3, 1)
                currentModuleName = v
            }
            currentModuleNameParts = string.split(currentModuleName, ".")
        }
        table.remove(currentModuleNameParts, $len(currentModuleNameParts))
    }
    // WARN: maybe multi result
    return require(moduleFullName)
}
handler = function (target, method) {
    return function () {
        return method.apply(target, arguments)
    }
}
// math.newrandomseed = function () {
//     var [ok, socket] = pcall(function () {
//         // WARN: maybe multi result
//         return require("socket")
//     })
//     if (ok) {
//         math.randomseed(socket.gettime() * 1000)
//     } else {
//         math.randomseed(os.time())
//     }
//     math.random()
//     math.random()
//     math.random()
//     math.random()
// }
math.round = function (value) {
    value = checknumber(value)
    // WARN: maybe multi result
    return Math.floor(value + 0.5)
}
var pi_div_180 = Math.PI / 180
math.angle2radian = function (angle) {
    return angle * pi_div_180
}
var pi_mul_180 = 180 / Math.PI
math.radian2angle = function (radian) {
    return radian * pi_mul_180
}
io.exists = function (path) {
    var file = io.open(path, "r")
    if (file) {
        io.close(file)
        return true
    }
    return false
}
io.readfile = function (path) {
    var file = io.open(path, "r")
    if (file) {
        var content = file.read("*a")
        io.close(file)
        return content
    }
    return null
}
io.writefile = function (path, content, mode) {
    mode = mode || "w+b"
    var file = io.open(path, mode)
    if (file) {
        if (file.write(content) == null) {
            return false
        }
        io.close(file)
        return true
    } else {
        return false
    }
}
io.pathinfo = function (path) {
    var pos = string.len(path)
    var extpos = pos + 1
    while (pos > 0) {
        var b = string.byte(path, pos)[0]
        if (b === 46) { // 46 = char "."
            extpos = pos
        } else if (b === 47) { // 47 = char "/"
            break
        }
        pos = pos - 1
    }
    var dirname = string.sub(path, 1, pos)
    var filename = string.sub(path, pos + 1)
    extpos = extpos - pos
    var basename = string.sub(filename, 1, extpos - 1)
    var extname = string.sub(filename, extpos)
    return table(
        [1, "dirname", dirname],
        [1, "filename", filename],
        [1, "basename", basename],
        [1, "extname", extname]
    )
}
io.filesize = function (path) {
    var size = false
    var file = io.open(path, "r")
    if (file) {
        var current = file.seek()
        size = file.seek("end")
        file.seek("set", current)
        io.close(file)
    }
    return size
}
table.nums = function (t) {
    var count = 0
    for (var k in t) {
        var v = t[k]
        count = count + 1
    }
    return count
}
table.keys = function (hashtable) {
    var keys = table()
    for (var k in hashtable) {
        var v = hashtable[k]
        keys[$len(keys) + 1] = k
    }
    return keys
}
table.values = function (hashtable) {
    var values = table()
    for (var k in hashtable) {
        var v = hashtable[k]
        values[$len(values) + 1] = v
    }
    return values
}
table.merge = function (dest, src) {
    for (var k in src) {
        var v = src[k]
        dest[k] = v
    }
}
table.insertto = function (dest, src, begin) {
    begin = checkint(begin)
    if (begin <= 0) {
        begin = $len(dest) + 1
    }
    var len = $len(src)
    var $limit86 = len - 1
    for (var i = 0; i <= $limit86; i += 1) {
        dest[i + begin] = src[i + 1]
    }
}
table.indexof = function (array, value, begin) {
    var $var88 = begin || 1,$limit89 = $len(array)
    for (var i = $var88; i <= $limit89; i += 1) {
        if (array[i] === value) {
            return i
        }
    }
    return false
}
table.keyof = function (hashtable, value) {
    for (var k in hashtable) {
        var v = hashtable[k]
        if (v === value) {
            return k
        }
    }
    return null
}
table.removebyvalue = function (array, value, removeall) {
    var [c, i, max] = [0, 1, $len(array)]
    while (i <= max) {
        if (array[i] === value) {
            table.remove(array, i)
            c = c + 1
            i = i - 1
            max = max - 1
            if (!removeall) {
                break
            }
        }
        i = i + 1
    }
    return c
}
table.map = function (t, fn) {
    for (var k in t) {
        var v = t[k]
        t[k] = fn(v, k)
    }
}
table.walk = function (t, fn) {
    for (var k in t) {
        var v = t[k]
        fn(v, k)
    }
}
table.unique = function (t, bArray) {
    var check = table()
    var n = table()
    var idx = 1
    for (var k in t) {
        var v = t[k]
        if (!check[v]) {
            if (bArray) {
                n[idx] = v
                idx = idx + 1
            } else {
                n[k] = v
            }
            check[v] = true
        }
    }
    return n
}
string._htmlspecialchars_set = table()
string._htmlspecialchars_set["&"] = "&amp;"
string._htmlspecialchars_set["\""] = "&quot;"
string._htmlspecialchars_set["'"] = "&#039;"
string._htmlspecialchars_set["<"] = "&lt;"
string._htmlspecialchars_set[">"] = "&gt;"
string.htmlspecialchars = function (input) {
    for (var k in string._htmlspecialchars_set) {
        var v = string._htmlspecialchars_set[k]
        input = string.gsub(input, k, v)
    }
    return input
}
string.restorehtmlspecialchars = function (input) {
    for (var k in string._htmlspecialchars_set) {
        var v = string._htmlspecialchars_set[k]
        input = string.gsub(input, v, k)
    }
    return input
}
string.nl2br = function (input) {
    // WARN: maybe multi result
    return string.gsub(input, "\n", "<br />")
}
string.text2html = function (input) {
    input = string.gsub(input, "\t", "    ")
    input = string.htmlspecialchars(input)
    input = string.gsub(input, " ", "&nbsp;")
    input = string.nl2br(input)
    return input
}

String.prototype.gsub = function (target, replacement) {
    return string.gsub(this, target, replacement);
}

string.gsub = function(src, target, replacement){
    if(target || target === ""){
        return src;
    }
    replacement = replacement || ""
    if(src.indexOf("%") !== -1 || src.indexOf(".") !== -1){
        cc.warn("gsub may be boom");
    }
    return String.prototype.replace.call(src,target, replacement);
}

string.split = function (input, delimiter) {
    input = tostring(input)
    delimiter = tostring(delimiter)
    if ((delimiter === "")) {
        return false
    }

    return table([2, input.split(delimiter)])
}

string.ltrim = function (input) {
    // WARN: maybe multi result
    return string.gsub(input, "^[ \t\n\r]+", "")
}
string.rtrim = function (input) {
    // WARN: maybe multi result
    return string.gsub(input, "[ \t\n\r]+$", "")
}
string.trim = function (input) {
    input = string.gsub(input, "^[ \t\n\r]+", "")
    // WARN: maybe multi result
    return string.gsub(input, "[ \t\n\r]+$", "")
}
string.ucfirst = function (input) {
    return string.upper(string.sub(input, 1, 1)) + string.sub(input, 2)
}
function urlencodechar(xchar) {
    return "%" + string.format("%02X", ...string.byte(xchar))
}
string.urlencode = function (input) {
    // convert line endings
    input = string.gsub(tostring(input), "\n", "\r\n")
    input = string.gsub(input, "([^%w%.%- ])", urlencodechar)
    // WARN: maybe multi result
    return string.gsub(input, " ", "+")
}
string.urldecode = function (input) {
    input = string.gsub(input, "+", " ")
    input = string.gsub(input, "%%(%x%x)", function (h) {
        // WARN: maybe multi result
        return string.char(checknumber(h, 16))
    })
    input = string.gsub(input, "\r\n", "\n")
    return input
}
string.utf8len = function (input) {
    var len = string.len(input)
    var left = len
    var cnt = 0
    var arr = table(
        0,
        0xc0,
        0xe0,
        0xf0,
        0xf8,
        0xfc
    )
    while (left !== 0) {
        var tmp = string.byte(input, -left)[0]
        var i = $len(arr)
        while (arr[i]) {
            if (tmp >= arr[i]) {
                left = left - i
                break
            }
            i = i - 1
        }
        cnt = cnt + 1
    }
    return cnt
}
string.adapt = function (str, maxLen) {
    if (!str) {
        return ""
    }
    str = tostring(str)
    maxLen = maxLen || 1
    let len = string.len(str)
    let left = len
    let cnt = 0
    let arr = table(
        0,
        0xc0,
        0xe0,
        0xf0,
        0xf8,
        0xfc
    )
    while (left !== 0) {
        let tmp = string.byte(str, -left)[0]
        let i = $len(arr)
        while (arr[i]) {
            if (tmp >= arr[i]) {
                left = left - i
                break
            }
            i = i - 1
        }
        cnt = cnt + 1
        if (cnt >= maxLen) {
            if (left === 0) {
                return str
            } else {
                return string.sub(str, 1, len - left) + "..."
            }
        }
    }
    return str
}
string.formatnumberthousands = function (num) {
    var formatted = tostring(checknumber(num))
    var k
    while (true) {
        ;[formatted, k] = string.gsub(formatted, "^(-?%d+)(%d%d%d)", "%1,%2")
        if (k === 0) {
            break
        }
    }
    return formatted
}
trycall = function (func) {
    var __VA_ARG = $slice(arguments, 1)
    var args = table([2, __VA_ARG])
    // WARN: maybe multi result
    return xpcall(function () {
        // WARN: maybe multi result
        return func(...unpack(args))
    }, function (msg) {
        cc.log(debug.traceback())
        cc.log(msg)
    })
}